// ── Iyanna Chess Themes ─────────────────────────────────────────────────
// Board square colors + piece colors the player can choose. Stored on the
// device so the choice sticks. Every theme keeps strong light/dark piece
// contrast so both sides are always clearly distinguishable — including
// for spectators.

export const BOARD_THEMES = [
  { id: 'heritage', name: 'Heritage', light: '#EDD9AE', dark: '#8A5A2E' },
  { id: 'msitu', name: 'Msitu', light: '#EBEED2', dark: '#6E9552' },
  { id: 'bahari', name: 'Bahari', light: '#DDE7EC', dark: '#4A7A96' },
  { id: 'usiku', name: 'Usiku', light: '#AEB6C4', dark: '#3B4252' },
  { id: 'iyanna', name: 'Iyanna', light: '#F0EAD8', dark: '#1F6B45' },
];

export const PIECE_THEMES = [
  { id: 'klasiki', name: 'Klasiki', w: '#FAF9F5', wStroke: '#2B2B2B', b: '#161616', bStroke: 'rgba(255,255,255,0.28)' },
  { id: 'iyanna', name: 'Iyanna', w: '#FFB74D', wStroke: '#5C3300', b: '#0B3524', bStroke: '#EAD37E' },
  { id: 'shaba', name: 'Shaba', w: '#F2E8D5', wStroke: '#6B4A1F', b: '#5C3A1E', bStroke: '#F2E8D5' },
  { id: 'zambarau', name: 'Zambarau', w: '#EDE7F6', wStroke: '#4527A0', b: '#311B58', bStroke: '#D1C4E9' },
];

const BOARD_KEY = 'iyanna_chess_board_theme';
const PIECE_KEY = 'iyanna_chess_piece_theme';

export function getBoardTheme() {
  try {
    const id = localStorage.getItem(BOARD_KEY);
    return BOARD_THEMES.find(t => t.id === id) || BOARD_THEMES[0];
  } catch { return BOARD_THEMES[0]; }
}

export function getPieceTheme() {
  try {
    const id = localStorage.getItem(PIECE_KEY);
    return PIECE_THEMES.find(t => t.id === id) || PIECE_THEMES[0];
  } catch { return PIECE_THEMES[0]; }
}

/** Cycle to the next board theme and persist it. Returns the new theme. */
export function nextBoardTheme() {
  const cur = getBoardTheme();
  const i = BOARD_THEMES.findIndex(t => t.id === cur.id);
  const next = BOARD_THEMES[(i + 1) % BOARD_THEMES.length];
  try { localStorage.setItem(BOARD_KEY, next.id); } catch {}
  return next;
}

/** Cycle to the next piece theme and persist it. Returns the new theme. */
export function nextPieceTheme() {
  const cur = getPieceTheme();
  const i = PIECE_THEMES.findIndex(t => t.id === cur.id);
  const next = PIECE_THEMES[(i + 1) % PIECE_THEMES.length];
  try { localStorage.setItem(PIECE_KEY, next.id); } catch {}
  return next;
}
